import { render, staticRenderFns } from "./PriceDiscovery.vue?vue&type=template&id=1592e0bb&scoped=true&"
import script from "./PriceDiscovery.vue?vue&type=script&lang=js&"
export * from "./PriceDiscovery.vue?vue&type=script&lang=js&"
import style0 from "./PriceDiscovery.vue?vue&type=style&index=0&id=1592e0bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1592e0bb",
  null
  
)

export default component.exports